"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAssetsData = exports.assetFormRules = exports.assetFieldMapping = exports.assetSchema = void 0;
const converters_1 = require("../../converters");
exports.assetSchema = {
    fields: {
        institution_name: {
            maxLength: 50,
        },
        name_on_account: {
            maxLength: 50,
        },
        institution_street_line1: {
            maxLength: 100,
        },
        institution_street_line2: {
            maxLength: 100,
        },
        institution_street_line3: {
            maxLength: 100,
        },
        institution_city: {
            maxLength: 50,
        },
        institution_state_code: {
            maxLength: 50,
        },
        institution_country_code: {
            maxLength: 2,
        },
        institution_postal_code: {
            maxLength: 20,
        },
        contact_name: {
            maxLength: 50,
        },
        contact_email: {
            maxLength: 74,
        },
        routing_number: {
            maxLength: 250,
        },
        account_number: {
            required: true,
            maxLength: 18,
        },
        market_value: {
            min: 1,
        },
    },
    messages: {
        institution_name: {
            maxLength: 'Institution Name must be 50 characters or less',
        },
        name_on_account: {
            maxLength: 'Name on Account must be 50 characters or less',
        },
        institution_street_line1: {
            maxLength: 'Address Line 1 must be 100 characters or less',
        },
        institution_street_line2: {
            maxLength: 'Address Line 2 must be 100 characters or less',
        },
        institution_street_line3: {
            maxLength: 'Address Line 3 must be 100 characters or less',
        },
        institution_city: {
            required: 'City is required',
            maxLength: 'City must be 50 characters or less',
        },
        institution_state_code: {
            maxLength: 'State must be 50 characters or less',
        },
        institution_country_code: {
            maxLength: 'Country must be 2 characters or less',
        },
        institution_postal_code: {
            maxLength: 'Zip Code must be 20 characters or less',
        },
        contact_name: {
            maxLength: 'Contact Name must be 50 character or less',
        },
        contact_email: {
            maxLength: 'Contact Email must be 74 characters or less',
        },
        routing_number: {
            maxLength: 'Routing Number must be 250 characters or less',
        },
        account_number: {
            maxLength: 'Account Number must be 18 characters or less',
        },
        market_value: {
            min: 'Market Value must be greater than 0',
        },
    },
};
// Field mapping between DTO naming and UI naming
exports.assetFieldMapping = {
    institution_name: 'institution_name',
    name_on_account: 'name_on_account',
    institution_street_line1: 'institution_street_line1',
    institution_street_line2: 'institution_street_line2',
    institution_street_line3: 'institution_street_line3',
    institution_city: 'institution_city',
    institution_state_code: 'institution_state_code',
    institution_country_code: 'institution_country_code',
    institution_postal_code: 'institution_postal_code',
    contact_name: 'contact_name',
    contact_phone_number: 'contact_phone_number',
    contact_fax_number: 'contact_fax_number',
    contact_email: 'contact_email',
    account_number: 'account_number',
    routing_number: 'routing_number',
    market_value: 'market_value',
};
// 🚀 Pre-computed validations for performance
exports.assetFormRules = (0, converters_1.toReactHookForm)(exports.assetSchema, exports.assetFieldMapping);
exports.validateAssetsData = (0, converters_1.createValidator)(exports.assetSchema);
